<template>
	<div class="dt-companies-top-bar hidden flex-row items-center gap-4 md:flex">
		<Search />
		<HeadquartersLocation :countries="props.countries" />
		<Industry :sectors="props.sectors" />
		<CompanySize :sizes="props.sizes" />
		<AddNew />
	</div>
	<div class="dt-companies-top-bar flex flex-row items-center gap-4 md:hidden">
		<Search />
		<el-button @click="drawer = true" text class="dt-home-filter-button">
			<FilterListIcon />
		</el-button>
		<el-drawer v-model="drawer" title="Filter Companies" modal-class="dt-companies-home-drawer" size="80%">
			<div class="flex flex-col gap-y-4">
				<HeadquartersLocation :countries="props.countries" />
				<Industry :sectors="props.sectors" />
				<CompanySize :sizes="props.sizes" />
			</div>
		</el-drawer>
	</div>
</template>

<script setup>
import FilterListIcon from "@/components/Svg/FilterListIcon.vue";
import { ref } from "vue";
import AddNew from "./AddNew.vue";
import CompanySize from "./CompanySize.vue";
import HeadquartersLocation from "./HeadquartersLocation.vue";
import Industry from "./Industry.vue";
import Search from "./Search.vue";

const props = defineProps({
	countries: { type: Object },
	sectors: { type: Object },
	sizes: { type: Object },
});
const drawer = ref(false);
</script>
